var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStripePlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4246_57956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 0H56.0001C60.4001 0 64 3.59993 64 8.00001V56C64 60.4001 60.4001 64 56.0001 64H7.99992C3.59993 64 0 60.4001 0 56V8.00001C0 3.59993 3.59993 0 7.99992 0V0Z",
    fill: "#FF385C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1328 33.5366L42.1328 14.4008C42.1328 13.5206 41.4123 12.8008 40.5328 12.8008H37.3328C36.4532 12.8008 35.7328 13.521 35.7328 14.4008V34.9371C35.7328 40.3862 31.3154 44.8037 25.8662 44.8037C20.417 44.8037 15.9996 40.3862 15.9996 34.9371V33.1245C15.9996 32.2443 15.2795 31.5245 14.3997 31.5245H11.1996C10.3199 31.5245 9.59968 32.2446 9.59968 33.1245L9.59961 34.9371C9.59954 43.9209 16.8824 51.2038 25.8662 51.2038C31.2769 51.2038 36.0697 48.5613 39.0269 44.4974L39.8835 43.7787L49.7159 52.029C50.3901 52.5946 51.4043 52.506 51.9699 51.8318L54.0269 49.3804C54.5926 48.7062 54.5038 47.692 53.8298 47.1264L44.8617 39.6013L49.9631 35.3209C50.6372 34.7552 50.7259 33.741 50.1602 33.0668L48.1032 30.6154C47.5376 29.9413 46.5234 29.8525 45.8492 30.4182L42.1328 33.5366ZM11.9065 12.8008H15.1067C15.9867 12.8008 16.7065 13.5208 16.7065 14.4008V17.6008C16.7065 18.4808 15.9867 19.2008 15.1067 19.2008H11.9065C11.0265 19.2008 10.3067 18.4808 10.3067 17.6008V14.4008C10.3067 13.5208 11.0265 12.8008 11.9065 12.8008Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4246_57956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStripePlans);
export default __webpack_public_path__ + "static/media/icon-stripe-plans.41564e550ebd872407e699fbb182769a.svg";
export { ForwardRef as ReactComponent };